import { KeyRound, Lock, SquareUserRoundIcon } from 'lucide-react'
import { Outlet } from 'react-router'
import { PATHS } from '@/app/router/routes'
import { SubNav } from '@/shared/components/subnav/subnav'
import { SubNavLink } from '@/shared/components/subnav/subnav-link'
import { SubNavSection } from '@/shared/components/subnav/subnav-section'
import { FEATURES } from '@/shared/config/features'

const LayoutAccount = () => {
  return (
    <div className="w-full h-full flex flex-col lg:flex-row overflow-hidden bg-neutral-50 dark:bg-background">
      <SubNav title="Cuenta">
        <SubNavSection>
          <SubNavLink to={PATHS.admin.account.general}>
            <SquareUserRoundIcon className="w-4 h-4 stroke-current" /> General
          </SubNavLink>
          <SubNavLink to={PATHS.admin.account.security}>
            <Lock className="w-4 h-4 stroke-current" /> Seguridad
          </SubNavLink>
          {FEATURES.apiTokensV2 ? (
            <SubNavLink to={PATHS.admin.account.apiTokens}>
              <KeyRound className="w-4 h-4 stroke-current" /> API tokens
            </SubNavLink>
          ) : null}
        </SubNavSection>
      </SubNav>
      <div className="flex-1 h-full overflow-scroll bg-neutral-50 dark:bg-background p-12">
        <Outlet />
      </div>
    </div>
  )
}

export default LayoutAccount
